import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Progress } from './Progress';
import { TaskForm } from './TaskForm';
import { TaskList } from './TaskList';

import { SelectOption } from '@/components/ui/SelectOptions/types';
import { useTasks } from './_hooks/useTasks';

import * as S from '@/components/ActionPlan/styles';

interface TasksProps {
	users: SelectOption[];
	descriptionTasks?: string;
	modal?: boolean;
	actionPlanId?: string;
}

export function Tasks({ users, descriptionTasks = '', modal = false, actionPlanId }: Readonly<TasksProps>): JSX.Element {
	const { taskList, percentProgress, handleOnAddTask } = useTasks(actionPlanId);

	return (
		<Row>
			<Col span={24}>
				<S.CustomLabel>{I18n.get('Tasks')}</S.CustomLabel>
			</Col>
			<Col span={24}>{descriptionTasks && <S.CustomText>{descriptionTasks}</S.CustomText>}</Col>
			<Col span={24}>
				<Progress total={taskList.length} completed={percentProgress} />
			</Col>
			<Col span={24}>
				<TaskForm users={users} limitDate={undefined} onAddTask={handleOnAddTask} modal={modal} />
			</Col>
			<Col span={24}>
				<Form.Item name="task_list">
					<TaskList users={users} value={taskList}/>
				</Form.Item>
			</Col>
		</Row>
	);
}
